import type { City, Match, Round, Stadium, Translated } from '@uefadigital/panenka';

import type { Enum } from './enum.types';

export type ModuleKey =
  | 'header'
  | 'yourteam'
  | 'info'
  | 'slot_include'
  | 'keydates'
  | 'ticketprices'
  | 'goodtoknow'
  | 'faq'
  | 'thirdparty'
  | 'langdisclaimer'
  | 'article';

export type TicketingOptions = {
  selectedKeyDateItem?: number;
  keyDatesShowDisclaimer?: boolean;
  showAllTitles?: boolean;
  enabledModulesKey?: ModuleKey[];
  competitionId?: string;
  seasonYear?: string;
  ticketingApiUrl?: string;
  matchApiUrl?: string;
  showDemands?: boolean;
  showViewSeats?: boolean;
  showPrices?: boolean;
  demandTags?: Record<DEMAND_LEVEL, string>;
  ticketsPortalUrl?: string;
  useTeamCode?: boolean;
  useCityIcons?: boolean;
  timezone?: string;
  ticketPricesTitle?: string;
  slotLibrary?: string;
  disableInteraction?: boolean;
  maxVisibleItems?: number;
  slotArticleLibrary?: string;
};

export type TicketingInfo = {
  matchId?: string;
  categoryCode: string;
  ticketCurrency: string;
  ticketPrice: string;
  ticketType: string;
  demandLevel?: DEMAND_LEVEL;
};

export const DEMAND_LEVEL = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  VERY_HIGH: 'VERY_HIGH',
  NOT_AVAILABLE: 'NOT_AVAILABLE',
} as const;
export type DEMAND_LEVEL = Enum<typeof DEMAND_LEVEL>;

export type MatchWithTickets = Match & {
  tickets: TicketingInfo[];
};

export type ScheduleMatch = {
  round: Translated<Round>;
  matches: MatchWithTickets[];
};

export type CityMatch = {
  stadium: Translated<Stadium>;
  city: Translated<City>;
  matches: MatchWithTickets[];
};

export const CURRENCY = {
  CHF: 'CHF',
  $: '$',
  '€': '€',
  '£': '£',
} as const;
export type CURRENCY = Enum<typeof CURRENCY>;
